module.exports = __webpack_public_path__ + "static/img/rank_91.01a338a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_91.png
// module id = c9NQ
// module chunks = 1